
import TranResourcesApi from './src/Tranresources'
import RegionApi from './src/Region'



let apis = {
   TranResourcesApi,
   RegionApi
};

export default apis;
